import { useTranslation } from "react-i18next";

export default function TrustSection() {
  const { t } = useTranslation();

  const trustItems = [
    { icon: "ri-calendar-check-line", title: t("trust.item1.title"), desc: t("trust.item1.desc") },
    { icon: "ri-check-double-line", title: t("trust.item2.title"), desc: t("trust.item2.desc") },
    { icon: "ri-guide-line", title: t("trust.item3.title"), desc: t("trust.item3.desc") },
    { icon: "ri-user-line", title: t("trust.item4.title"), desc: t("trust.item4.desc") },
    { icon: "ri-translate-2", title: t("trust.item5.title"), desc: t("trust.item5.desc") },
  ];

  return (
    <section className="relative w-full bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-6">
            Confiabilidade
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            {t("trust.title")}
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm">
            Nossa spreadsheet é mantida com os mais altos padrões de qualidade e transparência
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-2xl p-6 text-center group hover:bg-primary-50 transition-colors duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${item.icon} text-accent-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}